
import Text from "components/Text";

const OperatingRegulations = () => {
    return <Text type={"h1"}></Text>
}

export default OperatingRegulations;